// 예약 달력 공휴일 API

import { serverApi, handleApiResponse } from "@core/api/core"
import { createAsyncThunk } from "@reduxjs/toolkit"
import type { RootState } from "@core/store"

export interface ReservationHolidayMonthResponse {
  yearMonth: string
  generatedDate: string
  holidays: Record<string, string>
}

export const getReservationHolidayMonth = async (year: number, month: number): Promise<ReservationHolidayMonthResponse> => {
  const response = await serverApi.get("/hospital/public/setting/reservation-holidays/", { params: { year, month } })
  return handleApiResponse<ReservationHolidayMonthResponse>(response)
}

// 월별 공휴일 fetch thunk (중복요청 방지 condition 포함)
export const fetchReservationHolidayMonth = createAsyncThunk<
  ReservationHolidayMonthResponse,
  { year: number; month: number },
  { state: RootState; rejectValue: string }
>(
  "holidayCalendar/fetchMonth",
  async ({ year, month }, { rejectWithValue }) => {
    try {
      return await getReservationHolidayMonth(year, month)
    } catch (e: any) {
      return rejectWithValue(e?.message || "공휴일 조회 실패")
    }
  },
  {
    condition: ({ year, month }, { getState }) => {
      const yearMonth = `${year}-${String(month).padStart(2, "0")}`
      const state = getState()
      // 이미 로딩 중이거나 데이터가 있으면 중복 요청 방지
      if (state.holidayCalendar.loadingByMonth[yearMonth]) return false
      if (state.holidayCalendar.months[yearMonth]) return false
      return true
    },
  }
)
